import { cva, VariantProps } from 'class-variance-authority'
import clsx from 'clsx'
import React, { useMemo } from 'react'

import { Alert, ErrorIcon } from '@/components-latest/primitives/Icons'
import Text from '@/components-latest/primitives/Text'

import Styles from './AlertText.module.scss'

const alertTextVariants = cva(Styles.base, {
  variants: {
    variant: {
      warning: Styles.warning,
      error: Styles.error
    },
    icons: {
      warning: <Alert />
    }
  },
  defaultVariants: {
    variant: 'warning'
  }
})

interface Props
  extends React.HTMLAttributes<HTMLParagraphElement>,
    VariantProps<typeof alertTextVariants> {
  text: string
}

const AlertText = React.memo(
  ({ variant = 'warning', className, text }: Props) => {
    const icons = useMemo(
      () => ({
        warning: <Alert />,
        error: <ErrorIcon />
      }),
      []
    )

    return (
      <p
        className={clsx(
          Styles.alert,
          className,
          alertTextVariants({ variant })
        )}>
        {icons?.[variant as keyof typeof icons] || <></>}
        <Text className={Styles.text} variant="nextSubtitle" asChild>
          <p>{text}</p>
        </Text>
      </p>
    )
  }
)

AlertText.displayName = 'AlertText'
export default AlertText
